import { Handle, type NodeProps } from "@xyflow/react";
import type { FieldNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export function FieldNode({ data }: NodeProps) {
  const d = data as FieldNodeData;
  const { outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div className="rounded-md border border-green-300 bg-green-50 px-3 py-2 text-xs shadow-sm min-w-[100px]">
      <div className="font-medium text-green-700 text-[10px] mb-0.5">
        FIELD
      </div>
      <div className="text-green-900 font-mono truncate max-w-[160px]">
        {d.path || "—"}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
